import { AlertCircle, CheckCircle2, Info } from 'lucide-react'

interface ToastProps {
  message: string | null
  type?: 'error' | 'success' | 'info'
}

export function Toast({ message, type = 'error' }: ToastProps) {
  if (!message) return null
  const classes = type === 'success'
    ? 'bg-green-600 border-green-400'
    : type === 'info'
      ? 'bg-slate-800 border-slate-600'
      : 'bg-red-600 border-red-400'
  const Icon = type === 'success' ? CheckCircle2 : type === 'info' ? Info : AlertCircle
  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[9999] w-[calc(100%-2rem)] max-w-xl pointer-events-none">
      <div className={`${classes} text-white border shadow-2xl rounded-xl px-4 py-3 flex items-center gap-3 animate-slide-down`}>
        <Icon size={18} className="shrink-0" />
        <span className="text-sm font-semibold break-words">{message}</span>
      </div>
    </div>
  )
}
